<template>
  <v-autocomplete
    v-model="internalValue"
    :items="items"
    item-text="key"
    item-value="key"
    :label="label"
    :disabled="disabled"
    :clearable="clearable"
    :loading="loading"
    return-object
  />
</template>

<script>
import firebase from "firebase";
import VueTypes from "vue-types";
import {deserialize} from "serializr";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";

export default {
  name: "mapkind-dropdown",
  props: {
    label: VueTypes.string.def("Map Kind"),
    disabled: VueTypes.bool.def(false),
    clearable: VueTypes.bool.def(true),
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  mounted() {
    this.fetchMapKinds();
  },
  methods: {

    // 7fee6551fcfe4f3ea5c3d801e3e34a6c is a static GLOBAL_DEVELOPMENT config uid
    fetchMapKinds() {
      this.loading = true;
      firebase
        .database()
        .ref("/configs_data/7fee6551fcfe4f3ea5c3d801e3e34a6c/map-kind")
        .once("value")
        .then(snapshot => {
          let raw = snapshot.val() || {};
          console.log("RAW MapKinds:", raw);
          this.items = Object.values(raw).map(v => {
            const model = deserialize(MapKindLiteModel, v);
            console.log("Deserialized model:", model);
            return model;
          });
          console.log("Final items:", this.items);
        })
        .catch(err => {
          console.error("MapKind not loaded:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>